import {Injectable} from '@angular/core'

import {throwError as observableThrowError, Observable, of} from 'rxjs'
import {parseString} from 'xml2js'

@Injectable()
export class TsfService {
  constructor() {}

  getSettingsNode(obj: any): any {
    if (
      obj === undefined ||
      obj.savedSettings === undefined ||
      obj.savedSettings.settings === undefined
    ) {
      return undefined
    }
    return obj.savedSettings.settings
  }

  toMap(xml: String): Observable<any> {
    let res
    const obj = parseString(xml, {explicitArray: true}, (error, result) => {
      if (error) {
        return observableThrowError(error)
      } else {
        res = result
      }
    })
    const settings = {}
    const settingsNode = this.getSettingsNode(res)
    if (settingsNode === undefined) {
      return observableThrowError(
        new Error('File is not in the correct format'),
      )
    }
    for (const aidNode of settingsNode) {
      const aid = aidNode.$.aid
      for (const groupNode of aidNode.settingsGroup) {
        const group = groupNode.$.name
        for (const setNode of groupNode.setting) {
          const key =
            aid.toUpperCase() +
            '.' +
            group.toUpperCase() +
            '.' +
            setNode.$.name.toUpperCase()
          if (!this.filterKey(key)) {
            settings[key] = setNode._
          }
        }
      }
    }
    return of(settings)
  }

  filterKey(key: string): boolean {
    switch (key) {
      case '2.CL.KERNEL':
      case '2.CL.CERTIFICATES':
      case '2.CL.EXCEPTION':
      case '2.CT.KERNEL':
      case '2.CT.CERTIFICATES':
      case '2.CT.EXCEPTION':
      case '2.MS.KERNEL':
      case '2.ST.KERNEL':
      case '2.EMVCFG.ACQUIRER':
      case '2.EMVCFG.BEHAVIOR':
      case '2.EMVCFG.SSLCERTS': {
        return true
      }
      default: {
        return false
      }
    }
  }
}
